import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { ReactNode } from "react";

interface IModal {
	children: ReactNode;
	isOpen: boolean;
	setOpen: (x: boolean) => void;
	title: string;
	hasCloseIcon?: boolean;
}
const Modal = ({ children, isOpen, setOpen, title }: IModal) => {
	return (
		<Dialog open={isOpen} onOpenChange={setOpen}>
			<DialogTitle></DialogTitle>
			<DialogContent>
				<DialogHeader className="py-2">
					{title && <DialogTitle>{title}</DialogTitle>}
				</DialogHeader>
				<div>{children}</div>
			</DialogContent>
		</Dialog>
	);
};

export default Modal;
